// extracted by mini-css-extract-plugin
module.exports = {"container":"_23uDYnAqbyf4t9RXaLni-j"};